import type { ReactNode } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate } from "src/router";

// biome-ignore lint/style/useComponentExportOnlyModules: tiny flag hook co-located with its route gate; Fast Refresh loss is irrelevant here
export function useOpportunitiesEnabled(): boolean {
  const { adStudioOpportunitiesFeed } = useFlags();
  return import.meta.env.DEV || Boolean(adStudioOpportunitiesFeed);
}

export function OpportunitiesFeatureRoute({
  children,
  redirect,
}: {
  children: ReactNode;
  redirect: string;
}) {
  return useOpportunitiesEnabled() ? (
    <>{children}</>
  ) : (
    <Navigate to={redirect} replace />
  );
}
